function createDiv (classes, innerHTML) {
  const el = document.createElement('div')
  if (classes.length > 0) el.classList.add(...classes)
  if (innerHTML !== undefined) el.innerHTML = innerHTML
  return el
}

function getSelectedOption (selectElement) {
  const checked = selectElement.querySelector('option:checked')
  const first = selectElement.querySelector('option')
  return checked !== undefined ? checked : first
}

function appendQueryParameter (url, name, value) {
  const parsedUrl = new URL(url)
  if (value) {
    parsedUrl.searchParams.set(name, value)
  } else {
    parsedUrl.searchParams.delete(name)
  }
  return parsedUrl.href
}

function onItemClick (menuElement, labelElement, itemElement) {
  const items = Array.from(menuElement.children)
  items.forEach(el => el.classList.remove('same-as-selected'))
  labelElement.innerHTML = itemElement.innerHTML
  itemElement.classList.add('same-as-selected')
  if (itemElement.dataset.type !== undefined) {
    const value = itemElement.dataset.type
    const currentUrl = window.location.href
    const targetUrl = appendQueryParameter(currentUrl, 'type', value)
    if (targetUrl !== currentUrl) {
      window.location.replace(targetUrl)
    }
  }
  closeAllMenus()
}

function onLabelClick (menuElement, labelElement) {
  labelElement.classList.add('select-arrow-active')
  menuElement.classList.remove('select-hide')
}

function closeAllMenus () {
  const elements = document.querySelectorAll('.custom-select')
  elements.forEach(el => {
    const items = el.querySelector('.select-items')
    const label = el.querySelector('.select-selected')
    items.classList.add('select-hide')
    label.classList.remove('select-arrow-active')
  })
}

function setupListeners ({ menu, label }) {
  const options = menu.querySelectorAll('div')
  options.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation()
      onItemClick(menu, label, el)
    })
  })
  label.addEventListener('click', (e) => {
    e.stopPropagation()
    onLabelClick(menu, label)
  })
}

function getHtmlSelect (selectElement) {
  const selectedOption = getSelectedOption(selectElement)
  const label = createDiv(['select-selected'], selectedOption.innerHTML)
  const menu = createDiv(['select-items', 'select-hide'])
  const options = selectElement.querySelectorAll('option')
  Array.from(options).splice(1).forEach((op) => {
    const selected = op.innerHTML === selectedOption.innerHTML
    const classes = selected ? ['same-as-selected'] : []
    const el = createDiv(classes, op.innerHTML)
    Object.assign(el.dataset, op.dataset)
    menu.appendChild(el)
  })

  return { label, menu }
}

function bindAll () {
  const elements = document.querySelectorAll('.custom-select')
  elements.forEach((el) => {
    const select = el.querySelector('select')
    const htmlSelect = getHtmlSelect(select)
    setupListeners(htmlSelect)
    el.appendChild(htmlSelect.label)
    el.appendChild(htmlSelect.menu)
  })
  document.addEventListener('click', closeAllMenus)
}

bindAll()
